export enum DrugTypes {
    Synthetic = 1,
    Biotech = 2
};

export enum DrugGroups {
    Approved = 1,
    VetApproved = 2,
    Nutraceutical = 3,
    Illicit = 4,
    Withdrawn = 5,
    Investigational = 6,
    Experimental = 7
}

export enum MedicineTabs {
    Overview = 1,
    SideEffects = 2,
    Dosage = 3,
    Interactions = 4,
    Pregnancy = 5,
    DriveMachine = 6,
    Professional = 7,
    Leaflets = 8
}

export enum MedicineLeafletTypes {
    LeafletForUser = 1,
    SmPC = 2,
    EPAR = 3
}

export enum DiseaseType {
    InfectiousDisease = 1,
    DeficiencyDisease = 2,
    HereditaryDisease = 3,
    PhysiologicalDisease = 4,
    ChronicDisease = 5
}

export enum NotificationScheduleType {
    OneTime = 1,
    Recurring = 2
}

export enum NotificationAlarmType {
    Email = 1,
    PushNotification = 2
}

export enum NotificationFrequency {
    Hourly = 1,
    Daily = 2,
    //Weekly = 3
    // Monthly = 4
}

export enum ProfessionType {
    Driver = 1,
    MachineOperator = 2
}

export enum PregnancyType {
    Pregnancy = 1,
    Breastfeeding = 2
}

export enum GenderType {
    Male = 1,
    Female = 2
}

export enum BloodType {
    ZeroNeagtive = 1,
    ZeroPositive = 2,
    ANegative = 3,
    APositive = 4,
    BNegative = 5,
    BPositive = 6,
    ABNegative = 7,
    ABPositive = 8
}

export enum RelationType {
    Son = 1,
    Daughter = 2,
    Father = 3,
    Mother = 4,
    Sister = 5,
    Brother = 6,
    Husband = 7,
    Wife = 8,
    Other = 9
}

export enum UserConditionType {
    Height = 1,
    Weight = 2,
    BloodPressure = 3,
    HeartRate = 4,
    Temperature = 5,
    BloodSugar = 6
}

export enum UnitType {
    g = 1,
    mg = 2,
    mcg = 3,
    U = 4,
    TU = 5,
    MU = 6,
    mmol = 7,
    ml = 8
}

export enum InteractionType {
    Major = 1,
    Moderate = 2,
    Minor = 3,
    Unknown = 4
}

export enum AcceptanceType {
    BeforeEating = 1,
    WhileEating = 2,
    AfterEating = 3
}

export enum MinutesForIntake {
    Five = 5,
    Ten = 10,
    Fifteen = 15,
    Twenty = 20,
    Thirty = 30,
    Sixty = 60
}

export enum UserType {
    UserCreated = 1,
    Caretaker = 2
}

export enum RequestStatus {
    Waiting = 1,
    Approved = 2
}

export enum Lang {
    bg = 1,
    en = 2
}

export enum AuthorisationStatus {
    Authorised = 1,
    Withdrawn = 2,
    Refused = 3,
    Pending = 4,
    Suspended = 5
}

export enum DataSourceType {
    EMA = 1,
    BDA = 2
}

export enum LaboratoryTestType {
    Hemoglobin = 1,
    TotalCholesterol = 2,
    HighDensityLipoproteinCholesterol = 3,
    LowDensityLipoproteinCholesterol = 4,
    Triglycerides = 5,
    BloodSugar = 6
}

export enum FileSystemType {
    Leaflets = 1,
    LaboratoryResults = 2
}

export enum TimePresetType {
    OneDay = 1,
    OneWeek = 2,
    OneMonth = 3,
    ThreeMonths = 4,
    SixMonths = 5,
    OneYear = 6,
    Advanced = 7
}

//There is helper func that shifts enum to obje with param startsWithOne
export enum DayOfWeek {
    Monday = 0,
    Tuesday = 1,
    Wednesday = 2,
    Thursday = 3,
    Friday = 4,
    Saturday = 5,
    Sunday = 6
}

export enum DayOfWeekOneLetterAbbr {
    M = 0,
    T = 1,
    W = 2,
    R = 3,
    F = 4,
    S = 5,
    U = 6
}

export enum DayOfWeekThreeLetterAbbr {
    Mon = 0,
    Tue = 1,
    Wed = 2,
    Thu = 3,
    Fri = 4,
    Sat = 5,
    Sun = 6
}